module.exports = __webpack_public_path__ + "img/img-1.630ac09a.png";